<div *ngIf="lookupResponse && (phoneNumbers.length > 0 || emails.length > 0) && !isReviewContactFinished && !isSecondaryOTPNeeded">
  <div>
    <div class="access-codes my-2" style="text-align:center;padding:10px;">
      <adp-label labelKey="LookupUser_VerificationOption_Text_ConfirmInstruction"></adp-label>
    </div>
    <form class="col-12 px-0" [formGroup]="verificationOptionForm">
      <div>
        <mat-radio-group class="radio-group radio-group-container" sf-aria-label="Global_SelectOption_Aria_Label" formControlName="VerificationOption">
          <mat-radio-button style="text-align:left;" *ngFor="let option of verificationOptions" class="radio-field radio-button-container"
            [value]="option" [id]="option.Key">
            <span style="font-weight:600;">{{option.Value}}</span>
          </mat-radio-button>
        </mat-radio-group>
      </div>
      @if (isSPOEEnabled){
        <div class="mt-4">
          <adp-label labelKey="LookupUser_VerificationOption_Text_SPOE_Help_1"></adp-label>
          <a href="javascript:void(0);" (click)="showSupportInfo()"><adp-label labelKey="LookupUser_VerificationOption_Text_SPOE_Help_2"></adp-label></a>
        </div>
      }
      <div *ngIf="!showRatesAndTermsSectionBelow" [ngClass]="{'mt-2': showPhoneOption || showEmailOption, 'mt-3': !(showPhoneOption || showEmailOption)}">
        <div class="access-codes mb-2">
          <adp-label labelKey="LookupUser_VerificationOption_Text_RatesWarning"></adp-label>
        </div>
        <div class="terms">
          <adp-label labelKey="LookupUser_VerificationOption_Text_Terms"></adp-label>
        </div>
      </div>
      <div *ngIf="showRatesAndTermsSectionBelow" class="mt-2">
        <div class="terms mb-4">
          <adp-label labelKey="LookupUser_VerificationOption_Text_Terms"></adp-label>
        </div>
      </div>
      <div class="form-group mt-4 mb-3">
        <button mat-flat-button class="next-btn" color="accent" (click)="continue()" [disabled]="!verificationOptionForm.valid">
          <adp-label labelKey="LookupUser_VerificationOption_Button_Text"></adp-label>
        </button>
      </div>
    </form>
  </div>
</div>
<div *ngIf="isReviewContactFinished || isSecondaryOTPNeeded">
  <div class="access-codes review-container my-2" style="text-align:center;padding:10px;">
    <adp-label *ngIf="!isSecondaryOTPNeeded" labelKey="LookupUser_ReviewContact_Verify_ConfirmInstruction"></adp-label>
    <adp-label *ngIf="isSecondaryOTPNeeded" labelKey="LookupUser_SecondaryOtp_Verify_ConfirmInstruction"></adp-label>
    <p class="fw-600 mt-1 mb-1">{{contactInfo.primaryEmail}}</p>
  </div>
  <div class="form-group mt-4 mb-3">
    <button mat-flat-button class="next-btn" color="accent" (click)="continue()">
      <adp-label labelKey="LookupUser_VerificationOption_Button_Text"></adp-label>
    </button>
  </div>
</div>
